module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan2-1-f950ba8838c80841662a43824669474d.webp";